import BaseClient from './BaseClient';

class ThreadsClient extends BaseClient {
    threadsListUsingLink(link) {
        return this.makeCoreApiRequest(link);
    }

    threadsGetAll(teamId, params, config = {}) {
        return this.makeCoreApiRequest(`${this.apiBase}/teams/${teamId}/threads`, 'get', null, params, config);
    }

    threadsState(teamId, contactId, state) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/contacts/${contactId}/thread/${state === 'open' ? 'open' : 'close'}`;

        return this.makeCoreApiRequest(url, method);
    }

    threadsGetSummary(teamId, config = {}) {
        let method = 'get';
        let url = `${this.apiBase}/teams/${teamId}/threads/summary`;

        return this.makeCoreApiRequest(url, method, null, undefined, config);
    }

    threadsAssignToSelf(teamId, contactId) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/contacts/${contactId}/thread/claim`;

        return this.makeCoreApiRequest(url, method);
    }

    threadsAssignTo(teamId, contactId, claim) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/contacts/${contactId}/thread/assign`;

        return this.makeCoreApiRequest(url, method, claim);
    }

    threadsUnclaim(teamId, contactId) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/contacts/${contactId}/thread/unclaim`;

        return this.makeCoreApiRequest(url, method);
    }

    threadsCheckpointSave(teamId, contactId) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/contacts/${contactId}/thread/checkpoint`;

        return this.makeCoreApiRequest(url, method);
    }

    threadsCheckpointDelete(teamId, contactId) {
        let method = 'delete';
        let url = `${this.apiBase}/teams/${teamId}/contacts/${contactId}/thread/checkpoint`;

        return this.makeCoreApiRequest(url, method);
    }

    threadsCheckpointGet(teamId, contactId) {
        let method = 'get';
        let url = `${this.apiBase}/teams/${teamId}/contacts/${contactId}/thread/checkpoint`;

        return this.makeCoreApiRequest(url, method);
    }

    // Group API
    groupThreadsGetAll(teamId, groupId, params, config = {}) {
        return this.makeCoreApiRequest(
            `${this.apiBase}/teams/${teamId}/groups/${groupId}/threads`,
            'get',
            null,
            params,
            config
        );
    }

    groupThreadsState(teamId, groupId, contactId, state) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/groups/${groupId}/contacts/${contactId}/thread/${
            state === 'open' ? 'open' : 'close'
        }`;

        return this.makeCoreApiRequest(url, method);
    }

    groupThreadsGetSummary(teamId, groupId, config = {}) {
        let method = 'get';
        let url = `${this.apiBase}/teams/${teamId}/groups/${groupId}/threads/summary`;

        return this.makeCoreApiRequest(url, method, null, undefined, config);
    }

    groupThreadsAssignToSelf(teamId, groupId, contactId) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/groups/${groupId}/contacts/${contactId}/thread/claim`;

        return this.makeCoreApiRequest(url, method);
    }

    groupThreadsAssignTo(teamId, groupId, contactId, claim) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/groups/${groupId}/contacts/${contactId}/thread/assign`;

        return this.makeCoreApiRequest(url, method, claim);
    }

    groupThreadsUnclaim(teamId, groupId, contactId) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/groups/${groupId}/contacts/${contactId}/thread/unclaim`;

        return this.makeCoreApiRequest(url, method);
    }

    groupThreadsCheckpointSave(teamId, groupId, contactId) {
        let method = 'post';
        let url = `${this.apiBase}/teams/${teamId}/groups/${groupId}/contacts/${contactId}/thread/checkpoint`;

        return this.makeCoreApiRequest(url, method);
    }

    groupThreadsCheckpointDelete(teamId, groupId, contactId) {
        let method = 'delete';
        let url = `${this.apiBase}/teams/${teamId}/groups/${groupId}/contacts/${contactId}/thread/checkpoint`;

        return this.makeCoreApiRequest(url, method);
    }

    groupThreadsCheckpointGet(teamId, groupId, contactId) {
        let method = 'get';
        let url = `${this.apiBase}/teams/${teamId}/groups/${groupId}/contacts/${contactId}/thread/checkpoint`;

        return this.makeCoreApiRequest(url, method);
    }
}

export default new ThreadsClient({
    apiBase: window.Spark.apiBase,
});
